import {
  Box,
  Button,
  Divider,
  IconButton,
  Paper,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import SaveIcon from '@mui/icons-material/Save';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { sharedColors, sharedStyles } from '../../utils/Style';
import { extractYoutubeVideoID } from '../../utils/Youtube';
import { YoutubePreviewDialog } from '../YoutubePreviewDialog/YoutubePreviewDialog';

interface VideoUrlInputProps {
  title?: string;
  url?: string;
  onSubmit: (newUrl: string) => void;
  enableYoutubePreview?: boolean;
}

export const VideoUrlInput = (props: VideoUrlInputProps) => {
  const [value, setValue] = useState('');
  const [showYoutubeDialog, setShowYoutubeDialog] = useState(false);

  const videoID = extractYoutubeVideoID(value);

  useEffect(() => {
    setValue(props.url ?? '');
  }, [props.url]);

  return (
    <Paper
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: 400,
        height: 'fit-content',
        px: 3,
        pt: 1,
        pb: 3,
        gap: 1.5,
      }}
    >
      {!!videoID && (
        <YoutubePreviewDialog
          videoID={videoID}
          open={showYoutubeDialog}
          onClose={() => setShowYoutubeDialog(false)}
        />
      )}
      {props.title && (
        <>
          <Typography variant='h6'>{props.title}</Typography>
          <Divider sx={{ mt: -1 }} />
        </>
      )}
      <TextField
        label='Video Linki'
        variant='outlined'
        size='small'
        value={value}
        onChange={(e) => setValue(e.target.value)}
        slotProps={{
          input: {
            endAdornment: props.enableYoutubePreview && (
              <Tooltip
                title={
                  videoID
                    ? 'YouTube videosu önizleme'
                    : 'Geçersiz YouTube linki'
                }
              >
                <IconButton
                  disabled={!videoID}
                  onClick={() => setShowYoutubeDialog(true)}
                  sx={{ color: sharedColors.statusRed }}
                >
                  <YouTubeIcon />
                </IconButton>
              </Tooltip>
            ),
          },
        }}
        fullWidth
      />
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1.5 }}>
        <Box sx={{ flexGrow: 1 }} />
        <Button
          onClick={() => props.onSubmit(value)}
          variant='contained'
          size='small'
          startIcon={<SaveIcon />}
          sx={{ ...sharedStyles.buttonText }}
        >
          Kaydet
        </Button>
      </Box>
    </Paper>
  );
};
